var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.07031,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.07031,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#2B43DA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4444 21.1707V17.904C27.4444 17.3907 27.0444 16.9707 26.5556 16.9707H15.8889C15.4 16.9707 15 17.3907 15 17.904V27.2374C15 27.7507 15.4 28.1707 15.8889 28.1707H26.5556C27.0444 28.1707 27.4444 27.7507 27.4444 27.2374V23.9707L31 27.704V17.4374L27.4444 21.1707Z",
    fill: "#2B43DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.861148cef7f4be9c2ec168db56385896.svg";
export { ForwardRef as ReactComponent };